export enum CashCountViewType {
    DistributionPercentage = 0,
    DistributionCount = 1,
    DistributionValue = 2,
    TotalValue = 3,
}
